import React from "react";
import styles from "../application/application.module.scss";
import ServicesHome from "../reusable/servicesHome/ServicesHome";

const Application = () => {
  const application = [
    {
      heading: "Application Deployment",
      description:
        "Educate users about domains and simplify domain management. it aims to simplify domain management by providing user-friendly tools and guidance for registering, configuring, renewing, and transferring domains.A domain is a unique web address that allows users to access a website without remembering complex IP addresses. Choosing the right domain name is crucial for branding and online visibility. It should be short.",
    },
  ];
  return (
    <div className={styles.container}>
      <ServicesHome data={application} />
    </div>
  );
};

export default Application;
